import { render, staticRenderFns } from "./ImportCustomersModal.vue?vue&type=template&id=0bb1fdea"
import script from "./ImportCustomersModal.vue?vue&type=script&lang=js"
export * from "./ImportCustomersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports